import { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";

import { postTurno } from '../../../services/serviceTurno';
import { getCentrosRecreativos } from '../../../services/serviceCentroRecreativo';
import { getFechasCalendario } from '../../../services/serviceFechaCalendario';

import { useAuthContext } from "../../../context/auth";
import { dateToString } from "../../../utils/helpers/date.helpers";
import Contenedor from '../../../components/generalStructure/Contenedor/Contenedor';
import { ButtonConfirm } from '../../../components/Inputs/Buttons';
import ComboBox from '../../../components/Inputs/DropdownLists/ComboBox';
import Filtro from '../../../consulta/Filtrado/Filtro/Filtro';
import { useNavigate } from 'react-router-dom';
import AgregarInvitado from '../../invitados/components/AgregarInvitado';
import AgregarFamiliar from './AgregarFamiliar';
import { centroRecreativoVacio } from '../utils/constants/centroRecreativo.constants';
import ListaInvitados from '../../invitados/components/ListaInvitados';

const ContenedorSolicitudTurno = () => {

    const navigate = useNavigate();
    const { afiliado } = useAuthContext();

    console.log("el afiliado es,", afiliado)
    const [fechaDataPicker, setFechaDataPicker] = useState("");
    const [fecha, setFecha] = useState("");
    const fechasValidas = useRef([]);
    const [fechasCalendario, setFechasCalendario] = useState([]);
    

    const [titularSeleccionado, setTitularSeleccionado] = useState(false);
    const [grupoFamiliar, setGrupoFamiliar] = useState([]);
    const [invitados, setInvitados] = useState([])
    const [estadoAgregando, setEstadoAgregando] = useState(false)

    const [cri, setCri] = useState(centroRecreativoVacio);
    const [listaCris, setListaCris] = useState([]);
    const [topeInvitados, setTopeInvitados] = useState(null);

    const esFechaValida = date => {
        const dt_ddmmyyyy = dateToString(date);
        return fechasValidas.current.indexOf(dt_ddmmyyyy) != -1;
    };
    
    useEffect(() => {

        getCentrosRecreativos().then((cris)=>{

            const listaAux = [];

            cris.forEach((cri)=>{
                listaAux.push({ label: cri.descripcion, value: cri.id, topeInvitados: cri.topeInvitados});
            });

            setListaCris(listaAux);

        }).catch((err) => {
            toast.error("Hubo un error al buscar los centros recreativos");
            console.error("Error al buscar los centros recreativos", err);
        });

    }, []);

    // Limpiar invitados cuando se desmarca el titular
    useEffect(() => {
        if(!titularSeleccionado) {
            setInvitados([]);
        }
    }, [titularSeleccionado]);

    const generarTurno = () => {
        const fechaCalendarioID = fechasCalendario.filter(fechaCal => 
            (fechaCal.centroRecreativoID === cri.id && dateToString(fechaCal.fecha) == dateToString(fechaDataPicker))
        );

        postTurno(afiliado.dni, fechaCalendarioID[0].id, grupoFamiliar, invitados, titularSeleccionado).then(async (turnoGenerado) => {
            toast.success("El turno fue registrado con éxito.");
            navigate("/Turno/" + turnoGenerado.id);
            
            
        }).catch((err) => {
            toast.error(err.message);
            console.error("Error al querer registrar el turno", err);
        });
    }

    // const validarLimiteTurnosMensuales = () => {
    //     return false;
    //     getTurnos().then((disponibilidad) => {
    //         if(!disponibilidad){
    //             return true;
    //         }
    //     }).catch((err) => {
    //         toast.error("Hubo un error al buscar la disponibilidad de turnos mensuales");
    //         console.error("Hubo un error al buscar la disponibilidad de turnos mensuales", err);
    //     });
    // };

    const validarTurno = () => {
        if(cri.id === 0){
            toast.info("Debe seleccionar un centro recreativo.");
            return false;
        } else if(!fecha || !fecha.length){
            toast.info("Debe seleccionar una fecha.");
            return false;
        } else if(!titularSeleccionado && grupoFamiliar.length === 0){
            toast.info("Debe seleccionar al menos el titular o algún familiar.");
            return false;
        }  /*else if(validarLimiteTurnosMensuales()){
            toast.info("Usted excedió el nro de turnos disponibles en el mes.");
            return false;
        }*/
        return true;
    };

    const confirmarTurno = async () => {
        if(validarTurno()){
            generarTurno();
        }
    };

    // Función para obtener el texto de la alerta
    const obtenerTextoAlerta = () => {
        let texto = "¿Desea confirmar el turno?";
        if(!titularSeleccionado && grupoFamiliar.length > 0) {
            texto += " SIN TITULAR";
        }
        return texto;
    };

    // Verificar si hay algún participante seleccionado
    const hayParticipantesSeleccionados = titularSeleccionado || grupoFamiliar.length > 0;

    const cambiarCri = e => {
        const criID = parseInt(e.target.value);
        setCri({ id: criID, descripcion: e.target.options[e.target.selectedIndex].text});
        if(!criID){
            setFechasCalendario([]);
            fechasValidas.current = [];
            setTopeInvitados(null);
        } else{
            getFechasCalendario(criID).then(fValidas => {
                setFechasCalendario(fValidas);
                fechasValidas.current = fValidas.map(fechaVal => dateToString(fechaVal.fecha));
            })
            setTopeInvitados(listaCris.find(centro => centro.value === criID).topeInvitados);
        }
    }

    return (
        
        <Contenedor
            titulo="Solicitud del turno"
            className="mt-3 px-4"
        >

            <Filtro
                label="Centro recreativo"
                className="ps-1"
            >
                <ComboBox
                    valorPorDefecto={{label:"Seleccionar un centro recreativo", value:"0"}}
                    onChange={cambiarCri}
                    lista={listaCris}
                    value={cri.id}
                    className="mt-2"
                />
            </Filtro>
            
            <Filtro
                label="Fecha"
                className="pt-3 pb-1 ps-1"
            >
                <DatePicker
                    disabled={cri.id === 0}
                    title={cri.id === 0 ? "Debe seleccionar un centro recreativo": ""}
                    selected={fechaDataPicker}
                    onChange={date => { setFechaDataPicker(date); setFecha(dateToString(date)); }}
                    filterDate={esFechaValida}
                    className="form-control form-control-sm mt-2"
                    dateFormat="dd/MM/yyyy"
                    locale="es"
                />
            </Filtro>

            {
                ((afiliado.grupoFamiliar && afiliado.grupoFamiliar.length > 0) || afiliado) &&
                <AgregarFamiliar
                    listaFamiliares={afiliado.grupoFamiliar || []}
                    familiaresSeleccionados={grupoFamiliar}
                    setGrupoFamiliar={setGrupoFamiliar}
                    afiliado={afiliado}
                    titularSeleccionado={titularSeleccionado}
                    setTitularSeleccionado={setTitularSeleccionado}
                />
            }

            <hr/>

            {/* Mostrar invitados solo si el titular está seleccionado */}
            {titularSeleccionado && (
                <>
                    <ListaInvitados
                        invitados={invitados}
                        setInvitados={setInvitados}
                        soloLectura={false}
                        setEstadoAgregando={setEstadoAgregando}
                    />

                    {
                        cri.id !== 0 &&
                        <>
                            <AgregarInvitado
                                invitados={invitados}
                                setInvitados={setInvitados}
                                topeInvitados={topeInvitados}
                                estadoAgregando={estadoAgregando}
                                setEstadoAgregando={setEstadoAgregando}
                            />  

                            <hr/>
                        </>
                    }
                </>
            )}

        

            <div className="d-flex justify-content-center pt-3">
            
                <ButtonConfirm
                    textoAlerta={obtenerTextoAlerta()}
                    textoBotonPrincipal="Solicitar turno"
                    onClickConfirmar={confirmarTurno}
                    onClick={() => {
                        // Si no hay participantes, no activar la confirmación
                        if(!hayParticipantesSeleccionados) {
                            toast.info("Debe seleccionar al menos el titular o algún familiar.");
                            return false;
                        }
                        return validarTurno();
                    }}
                    classNameButton="py-1"
                    disabled={!hayParticipantesSeleccionados}
                />

            </div>
        
        </Contenedor>
   )
};

export default ContenedorSolicitudTurno;